import { webKnots } from '../../../common/back/lace/webKnots'
import { crossLace, withCrossJointLace } from '../lace/crossLace'
import { middleSidePartOfWeb, topSidePartOfWeb } from './parts/sideParts'
import { verticalPartOfWeb2 } from './parts/verticalParts'

export const yw14Web = (ctx: CanvasRenderingContext2D, webColor: string, web2Color: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // 横上パーツ
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1)
  // 縦パーツ
  verticalPartOfWeb2(ctx, web2Color, laceColor, stitchColor)
  withCrossJointLace(ctx, laceColor, 0, 0)
  crossLace(ctx, laceColor, 120, -150)
  crossLace(ctx, laceColor, 85, -100)
  crossLace(ctx, laceColor, 45, -50)
  webKnots(ctx, laceColor, -90, 100) // クロス中央の結び目
  webKnots(ctx, laceColor, -110, 120) // 捕球面上のウェブ結び目
}
